var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSent = function SvgSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.2 28.974v-27.5Q.2.674.873.25 1.55-.176 2.3.124l32.6 13.7q.9.4.9 1.4t-.9 1.4l-32.6 13.7q-.75.3-1.425-.125T.2 28.974m3-2.4 27.2-11.35-27.2-11.5v8.4l12.1 3.1-12.1 3zm0-11.35v-11.5 22.85z"
  })));
};
export default SvgSent;